// extracted by mini-css-extract-plugin
module.exports = {"dot":"three-dots-loader_dot__ii4k1","dotScale":"three-dots-loader_dotScale__7IH24"};